import React, { useState } from 'react';
import Slider from 'rc-slider';
import PropTypes from 'prop-types';
import 'rc-slider/assets/index.css';
import styles from './Revenue.module.scss';

function Revenue(props) {
  const { index, onChange, min = 0, max = 100, value: initialValue = 0 } = props;
  const [value, setValue] = useState(initialValue);

  const handleChange = (value) => {
    setValue(value);

    if (index === undefined) {
      onChange(value);
    } else {
      onChange(value, index);
    }
  };

  return (
    <div className={styles.container}>
      <Slider
        className={styles.slider}
        value={index === undefined ? value : props.value}
        onChange={handleChange}
        dotStyle={{
          borderColor: '#c8c8c9',
          backgroundColor: '#eeeeee',
        }}
        trackStyle={{
          backgroundColor: '#e119b9',
        }}
        railStyle={{
          backgroundColor: '#5c03ec',
        }}
        min={min}
        max={max}
      />
    </div>
  );
}

export default Revenue;

Revenue.propTypes = {
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  index: PropTypes.number,
};
